import React, { createContext, useContext, useState, useEffect } from "react";
import API from "../config/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("voice_ai_token");
    if (!token) { setLoading(false); return; }
    fetch(`${API.validateSession}?token=${token}`)
      .then(r => r.json())
      .then(d => { if (d.valid) setUser(d.user); else localStorage.removeItem("voice_ai_token"); })
      .catch(() => localStorage.removeItem("voice_ai_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("voice_ai_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("voice_ai_token");
    setUser(null);
  };

  const getToken = () => localStorage.getItem("voice_ai_token");

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
